import { format } from 'date-fns';

import { createAt, payloadToCreate } from '@billing/mappers/billing-id.mapper';
import { BillingPayload, BillingResponse } from '@billing/entities/billing.payload';
import { BookingArrangementExtraQuestionsVM, BookingArrangementVM } from '@booking/entities/booking-arrangement';
import {
  ActivitiesBookingExtraQuestion, ActivitiesBookPayloadVM, ActivitiesValidateResponse, ExtraQuestion, ExtraQuestionDataType
} from '@activities/entities/activities-booking';
import { getBaseTravelers } from '@pax/mappers/traveler-book.mapper';
import { TravelerItemUI } from '@pax/entities/pax-ui';
import { getFormKeyByQuestionCode } from '@activities/mappers/extra-questions.mapper';
import { isEmpty } from '@app/util/util';
import { dobToDate } from '@ux/mappers/date.mapper';

export function activitiesBookPayloadMapper(
  validate: ActivitiesValidateResponse, paxListUI: TravelerItemUI[],
  bookingFormValues: BookingArrangementVM, billing: BillingResponse,
): ActivitiesBookPayloadVM {
  const travelers = getBaseTravelers(bookingFormValues, paxListUI);
  const createIsEnabledByBilling = createAt(billing);
  return {
    arrangement: {
      ValidateToken: validate.ValidateToken,
      TravelItineraryId: 0,
      Passengers: travelers,
      TravelExtraQuestions: getExtraQuestions(validate.ExtraQuestions, bookingFormValues.ExtraQuestions),
    },
    billing: {
      createIsEnabled: createIsEnabledByBilling,
      payload: createIsEnabledByBilling ? payloadToCreate(billing, bookingFormValues) : {} as BillingPayload
    },
    assistance: null,
  };
}

function getExtraQuestions(
  questions: ExtraQuestion[], answers: BookingArrangementExtraQuestionsVM[]
): ActivitiesBookingExtraQuestion[] {
  if (questions?.length && answers?.length) {
    const answersVM = answers.map(answer => Object.keys(answer)
      .filter(formKey => formKey !== 'Key')
      .map(formKey => ({
        Question: questions.find(q => getFormKeyByQuestionCode(q.QuestionCode) === formKey),
        Answer: answer[formKey],
      }))
      .filter(awm => !isEmpty(awm?.Question))
    );
    return [].concat(...answersVM).map(awm => {
      const answerText = getAnswerText(awm.Answer, awm.Question);
      const answerOptionListId = awm.Question.QuestionOptionList?.find(ol => ol.Value === answerText)?.Key;
      return {
        QuestionCode: awm.Question.QuestionCode,
        AnswerText: answerText,
        ...(!isEmpty(awm.Question.QuestionOptionList) && !isEmpty(answerOptionListId)) && {
          AnswerOptionListId: answerOptionListId,
        }
      };
    });
  } else {
    return [];
  }
}

function getAnswerText(answer: unknown, question: ExtraQuestion): string {
  if (isEmpty(answer)) {
    return question.DataType === ExtraQuestionDataType.TrueFalse ? 'false' : '';
  } else {
    return question.DataType === ExtraQuestionDataType.Date ? format(dobToDate(`${answer}`), 'yyyy-MM-dd') : `${answer}`;
  }
}
